import { authSlice } from "./slice";

export const { setTokenAndMe, setBlank, logout, setLoading } = authSlice.actions;
